import RefLineBase from './ref-line-base'
import * as turf from '@turf/turf'

/**
 * 直線基準線
 */
export default class StraightRefLine extends RefLineBase {
  constructor(refLineGeoJson) {
    super(refLineGeoJson)
    this.eastEdgePoint = undefined // 基準線を東側に伸ばした端点
    this.westEdgePoint = undefined // 基準線を西側に伸ばした端点
    this.additionalNorthEdgePoints = [] // 基準線を北方向に作業幅で複製したポイント一覧
    this.additionalSouthEdgePoints = [] // 基準線を南方向に作業幅で複製したポイント一覧
  }

  prepare(workWidth) {
    const refCoordinates = this.refLineGeoJson.features[0].geometry.coordinates

    this.startPoint = turf.point(refCoordinates[0])
    this.endPoint = turf.point(refCoordinates[1])

    // east westを決定
    const longitude1 = turf.getCoord(this.startPoint)[0]
    const longitude2 = turf.getCoord(this.endPoint)[0]

    // 大きいほうが東側
    if (longitude1 > longitude2) {
      this.points.east = this.startPoint
      this.points.west = this.endPoint
    } else {
      this.points.east = this.endPoint
      this.points.west = this.startPoint
    }

    // 東西を結ぶ距離
    const length = turf.distance(this.points.west, this.points.east, RefLineBase.UNIT)

    // bearingは西から東
    const bearing = turf.bearing(this.points.west, this.points.east)

    const blockLength = 1000 // 1000m四方
    const edgeLength = blockLength / 2 - length / 2

    // 西側
    this.westEdgePoint = turf.destination(this.points.west, edgeLength, bearing - 180, RefLineBase.UNIT)

    // 東側
    this.eastEdgePoint = turf.destination(this.points.east, edgeLength, bearing, RefLineBase.UNIT)

    // 積算ポイント計算（北側）
    let additionDistance = 0
    let currentWestPoint = this.westEdgePoint
    let currentEastPoint = this.eastEdgePoint
    while (additionDistance < blockLength / 2) {
      additionDistance += workWidth
      currentWestPoint = turf.destination(currentWestPoint, workWidth, bearing - 90, RefLineBase.UNIT)
      currentEastPoint = turf.destination(currentEastPoint, workWidth, bearing - 90, RefLineBase.UNIT)
      this.additionalNorthEdgePoints.push({ west: currentWestPoint, east: currentEastPoint })
    }

    // 積算ポイント計算（南側）
    additionDistance = 0
    currentWestPoint = this.westEdgePoint
    currentEastPoint = this.eastEdgePoint
    while (additionDistance < blockLength / 2) {
      additionDistance += workWidth
      currentWestPoint = turf.destination(currentWestPoint, workWidth, bearing + 90, RefLineBase.UNIT)
      currentEastPoint = turf.destination(currentEastPoint, workWidth, bearing + 90, RefLineBase.UNIT)
      this.additionalSouthEdgePoints.push({ west: currentWestPoint, east: currentEastPoint })
    }

    // 中心
    this.center = turf.centroid(this.refLineGeoJson).geometry.coordinates
    this.boundingBox = turf.bbox(this.refLineGeoJson)
  }

  /**
   *  赤のMultiLine
   *
   * 基準線をEdgePointまで伸ばしたものと、積算されたEdgePointの奇数インデックス
   */
  get redMultiLineGeoJson() {
    let lines = []
    lines.push(this.toLineString(this.westEdgePoint, this.eastEdgePoint))
    this._appendPointsOrLine(lines, this.additionalNorthEdgePoints, { filter: 'odd', type: 'point' })
    this._appendPointsOrLine(lines, this.additionalSouthEdgePoints, { filter: 'odd', type: 'point' })
    return this.toMultiLineString(lines)
  }

  /**
   *  青のMultiLine
   *
   * 積算されたEdgePointの偶数インデックス
   */
  get blueMultiLineGeoJson() {
    let lines = []
    this._appendPointsOrLine(lines, this.additionalNorthEdgePoints, { filter: 'even', type: 'point' })
    this._appendPointsOrLine(lines, this.additionalSouthEdgePoints, { filter: 'even', type: 'point' })
    return this.toMultiLineString(lines)
  }
}
